export default __webpack_public_path__ + "static/media/J744_RoHS.6dd9e71d.pdf";